import { MEDIA_BREAKPOINTS } from '../constants/MEDIA_BREAKPOINTS';
import { isNullOrUndef } from '../utils/isNullOrUndef';
import { dlDispatchAmplEvent } from '../events/dl.dispatchAmplEvent';
class SectionPromoBar extends HTMLElement {
    discountCode = this.dataset.discountCode;
    successCloseTimer = 0;
    copyBar = this.querySelector('[data-c-bar]');
    successMsg = this.querySelector('[data-c-success]');
    constructor() {
        super();
        this.copyBar.addEventListener('click', this.copy.bind(this));
    }
    copy() {
        if (this.discountCode === undefined)
            return;
        navigator.clipboard.writeText(this.discountCode)
            .then(() => {
            this.showSuccess();
        })
            .catch(error => {
            console.log('Copy error:', error);
        });
        dlDispatchAmplEvent('Promo bar clicked to copy', { couponCode: this.discountCode });
    }
    showSuccess() {
        const successMsgDisappearTime = 2500;
        if (MEDIA_BREAKPOINTS.XL_UP.matches) {
            const tooltip = this.querySelector('tooltip-component');
            if (isNullOrUndef(tooltip))
                return;
            const oldTooltipText = tooltip.textContent;
            tooltip.textContent = this.successMsg.textContent;
            this.successCloseTimer !== 0 && clearTimeout(this.successCloseTimer);
            this.successCloseTimer = window.setTimeout(() => {
                tooltip.textContent = oldTooltipText;
            }, successMsgDisappearTime);
            return;
        }
        this.copyBar.ariaHidden = 'true';
        this.successMsg.ariaHidden = 'false';
        this.successCloseTimer !== 0 && clearTimeout(this.successCloseTimer);
        this.successCloseTimer = window.setTimeout(() => {
            this.copyBar.ariaHidden = 'false';
            this.successMsg.ariaHidden = 'true';
        }, successMsgDisappearTime);
    }
}
customElements.define('promo-bar-component', SectionPromoBar);
